import useUserSubscriptionProvider from "@/core/dataProviders/providers/auth/useUserSubscriptionProvider";
import { FEATURE_PERMISSIONS } from "@/core/types/permissions";
import { UseSubsPermissionsActionTypes } from "@/types/hooks";
import { useEffect, useState } from "react";

export default function useSubscriptionPermissionsChecker(key: string, featurePermission: FEATURE_PERMISSIONS) {
  const [isFeaturePermission, setIsFeaturePermission] = useState(false);
  const [subscriptions] = useUserSubscriptionProvider();
  const subsHasPermissions = subscriptions?.some((sub) => sub.access.includes(featurePermission))!;

  useEffect(() => {
    if (!subscriptions) {
      return setIsFeaturePermission(false);
    }
    switch (key) {
      case UseSubsPermissionsActionTypes.VALID_PERMISSIONS:
        setIsFeaturePermission(!!subscriptions.length && subsHasPermissions);
        break;
      case UseSubsPermissionsActionTypes.INVALID_PERMISSIONS:
        setIsFeaturePermission(!subscriptions.length || !subsHasPermissions);
        break;
      default:
        setIsFeaturePermission(false);
    }
  }, [key, subscriptions, subsHasPermissions]);

  return isFeaturePermission;
}
